<template>
  <v-snackbar v-model="toast.visible" :color="toast.color" :data-cy="'toast-' + toast.color" top>
    <span v-if="toast.itext">
      <span v-for="itext in iTextArray">{{ $t(itext) }} </span>
    </span>
    <span v-html="toast.text"></span>

    <template v-slot:action="{ attrs }">
      <v-btn color="white" text v-bind="attrs" @click="toast.visible = false">
        {{ $t('actions.close')}}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'LayoutToast',
  data () {
    return {
      toast: {
        visible: false,
        text: ''
      }
    }
  },
  methods: {
    onEvent ({ type, text, itext, modal }) {
      if (!modal) {
        this.toast.visible = true
        this.toast.text = text
        this.toast.itext = itext
        this.toast.color = type
      }
    }
  },
  computed: {
    iTextArray () {
      if(this.toast.itext.includes(',')) {
        return this.toast.itext.split(',')
      } else {
        return [this.toast.itext]
      }
    }
  },
  mounted () {
    this.$bus.on('ui/message', this.onEvent)
  },
  destroyed() {
    this.$bus.off('ui/message', this.onEvent)
  }
}
</script>

<style scoped>

</style>